import React from 'react';
import _ from 'lodash';
import { Grid } from 'semantic-ui-react';
import { useDispatch } from 'react-redux';
import AttachmentView from '../../../common/AttachmentView';
import { getFileName } from '../../../../HelperMethods/UtilityFunctions';
import AttachmentComponent from '../../../common/form-preview/AttachmentComponent';
import { FILE_UPLOAD_FORMAT_OPTIONS } from '../../../../HelperMethods/constants';
// eslint-disable-next-line import/no-cycle
import { setIsAdhocFileUploading } from './redux/actions';

export default function TaskAdhocAttachment({ attributeObj, formik }) {
  const attachments = _.get(formik.values, attributeObj.attributeName) ?? [];
  const dispatch = useDispatch();
  const onRemoveAttachmentClicked = React.useCallback(
    (attachmentIndex) => {
      const clonedAttachments = [...attachments];
      clonedAttachments.splice(attachmentIndex, 1);
      formik.setFieldValue(attributeObj.attributeName, clonedAttachments, false);
    },
    [formik, attachments, attributeObj]
  );
  const onFileUploaded = React.useCallback(
    (attachmentObj) => {
      const clonedAttachments = [...attachments];
      clonedAttachments.push(attachmentObj);
      formik.setFieldValue(attributeObj.attributeName, clonedAttachments, false);
    },
    [formik, attachments, attributeObj]
  );
  return (
    <Grid>
      <Grid.Row className="form-group-header">Adhoc Attachments</Grid.Row>
      <Grid.Row style={{ paddingLeft: '10px' }}>
        {(attachments || [])
          .filter((attachment) => attachment.key)
          .map((attachment, index) => (
            <AttachmentView
              key={attachment.key}
              attachment={attachment}
              name={attachment.fileName || getFileName(attachment.key)}
              isDownloadable
              onRemoveButtonClick={() => onRemoveAttachmentClicked(index)}
            />
          ))}
      </Grid.Row>
      <Grid.Row>
        <AttachmentComponent
          fileSizeLimitInMB={10}
          fieldName="Upload"
          onChange={onFileUploaded}
          allowedFormats={[FILE_UPLOAD_FORMAT_OPTIONS.image.id, FILE_UPLOAD_FORMAT_OPTIONS.pdf.id]}
          onUploadStatusChange={(uploadStatus) => {
            dispatch(setIsAdhocFileUploading(uploadStatus));
          }}
        />
      </Grid.Row>
    </Grid>
  );
}
